import { render } from "./ChamadosPorCliente.vue?vue&type=template&id=22e8e8fa"
import script from "./ChamadosPorCliente.vue?vue&type=script&lang=js"
export * from "./ChamadosPorCliente.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/alperlab/alperlab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__